<template>
    <v-container>
        <v-row class="center">
            <v-card class="slider-container">
                <v-flex class="add-button-container">
                    <site-button
                        colorClasses="secondary-icon"
                        :colNum="1"
                        @click-event="addSlide"
                        toolTip="New Advertisement"
                        iconType="ICON"
                        iconString="fas fa-plus-circle"
                    ></site-button>
                    <site-button
                        v-if="ads.length > 0"
                        colorClasses="secondary-icon"
                        :colNum="1"
                        @click-event="deleteSlide"
                        toolTip="Delete Advertisement"
                        iconType="ICON"
                        iconString="fas fa-trash"
                    ></site-button>
                    <site-button
                        v-if="hasChanges"
                        colorClasses="secondary-icon"
                        :colNum="1"
                        @click-event="submitAds"
                        toolTip="Save Changes"
                        iconType="ICON"
                        iconString="far fa-save"
                    ></site-button>
                </v-flex>
                <v-row class="center">
                    <h2>Slider Advertisements</h2>
                </v-row>
                <v-container v-if="ads.length > 0">
                    <v-row class="center">
                        <v-system-bar lights-out></v-system-bar>
                        <v-carousel v-model="currentIndex" :hide-delimiters="true" :continuous="false" :show-arrows="true" hide-delimiter-background height="450">
                            <v-carousel-item class="icon-click" v-for="(advertisement, i) in ads" :key="i">
                                <v-sheet style="height: 100%; width: 100%;" title="Change Photo" @click="openImageDialog(i)">
                                    <v-col v-if="advertisement.position !== 'None'" :class="positionedTop(advertisement.position) ? 'position-top' : 
                                        positionedBottom(advertisement.position) ? 'position-bottom' : 'position-center'">
                                        <h3 :style="`color: ${advertisement.labelColor}`">{{ advertisement.label }}</h3>
                                    </v-col>
                                    <v-img contain max-height="600" :src="advertisement.src" />
                                </v-sheet>
                            </v-carousel-item>
                        </v-carousel>
                    </v-row>
                    <v-row style="margin-top: 30px !important;" class="center">
                        <img v-if="selectedAd.isActive" style="width: 200px;" src="../../../assets/Active.png" />
                        <site-button
                            v-else-if="!selectedAd.isActive"
                            @click-event="setActive(currentIndex)"
                            :colNum="6"
                            :marginNumber="3"
                            :iconString="activationIcon"
                            iconType="SVG"
                            btnType="text"
                            text="Activate Ad"
                            colorClasses="secondary-icon"
                            iconColor="primary-icon"
                        ></site-button>
                        <site-button
                            v-if="selectedAd.isActive"
                            @click-event="setTargetMarket(currentIndex)"
                            :colNum="6"
                            :marginNumber="3"
                            :iconString="targetMarket"
                            iconType="SVG"
                            btnType="text"
                            text="Set Target Market"
                            colorClasses="secondary-icon"
                            iconColor="primary-icon"
                        ></site-button>
                    </v-row>
                </v-container>
                <span v-else>No Current Advertisements</span>
            </v-card>
        </v-row>
        <ad-dialog v-if="focusedAd" :hasChanges="hasChanges" :adObject="focusedAd" :index="focusedIndex" @save="submitAds"
            @activate="setActive" @delete="deleteSlide" @set-dialog-control="setDialogControl" :showDialog="openDialog"></ad-dialog>
    </v-container>
</template>

<style lang="scss" scoped>
@import '../../../styles/styles.scss';

::v-deep .v-window__next .v-btn {
    height: 50px;
    width: 50px;
}

::v-deep .v-window__prev .v-btn {
    height: 50px;
    width: 50px;
}

.position-top {
    position: absolute;
    top: 0;
    z-index: 1;
}

.position-center {
    position: absolute;
    z-index: 1;
}

.position-bottom {
    position: absolute;
    bottom: 0;
    z-index: 1;
}

.icon-click {
    cursor: pointer;
    background-size: 100%;
}

.carousel-input {
    display: none;
}
</style>

<script>
import AdConfigDialog from '../../../components/common/Business/AdConfigDialog'
import SiteButton from '../../../components/common/SiteButton'
import AdvertisementTypes from '../../../assets/Enums/AdvertisementType'
import LinkType from '../../../assets/Enums/LinkType'
import TrafficType from '../../../assets/Enums/TrafficType'
import utils from '../../../utilities/utils';
import { nanoid } from 'nanoid'

export default {
    components: {
        'ad-dialog': AdConfigDialog,
        'site-button': SiteButton
    },
    data: () => ({
        ads: [],
        focusedIndex: null,
        currentIndex: 0,
        openDialog: false,
        hasChanges: false,
    }),
    created(){
        console.log(this.$store.state.sliderAds);
        this.ads = this.$store.getters.sliderAds;
    },
    methods: {
        openImageDialog(index) {
            this.focusedIndex = index;
            this.openDialog = true;
            this.hasChanges = true;
        },
        addSlide() {
            if (this.ads.length < 5) {
                const currentDate = new Date(),
                    trafficKey = currentDate.toISOString().substring(0, 7);

                this.ads.push({
                    localId: nanoid(6),
                    label: `New Slide ${this.ads.length + 1}`,
                    partnerId: this.$store.getters.partnerId,
                    src: '',
                    srcFile: null,
                    type: AdvertisementTypes.SLIDER,
                    linkType: LinkType.None,
                    link: '',
                    labelColor: '',
                    position: null,
                    isActive: false,
                    targetMarket: {
                        ageStart: 21,
                        ageEnd: 70,
                        genders: [],
                        activeAreas: [],
                        keyWords: [],
                    },
                    traffic: {
                        entries: [{ term: trafficKey, day: currentDate.getDate(), traffic: 0, trafficType: TrafficType.SliderAd }],
                        trafficType: TrafficType.SliderAd
                    }
                });
                this.hasChanges = true;
            } else {
                this.$store.dispatch('SHOW_SNACKBAR', "You've reached your advertisement limit (5)")
            }
        },
        deleteSlide() {
            const localId = this.ads[this.currentIndex].localId;
            console.log('localId Delete: ' + JSON.stringify(localId));
            const delId = this.localAds?.findIndex(s => s && s.localId === localId);
            
            console.log(this.currentIndex + ' ' + delId);
            this.hasChanges = true;
            this.openDialog = false;

            if(delId > -1){
                console.log('del');
                this.$store.dispatch('DELETE_AD_DESIGN', delId);
            }

            this.ads.splice(this.currentIndex, 1);
            this.currentIndex = 0;
        },
        submitAds() {
            this.hasChanges = false;
            this.ads.forEach(async ad => {
                const adIndex = this.localAds?.findIndex(s => s && s.localId === ad.localId);
                ad.src = ad.srcFile ? await utils.getBase64(ad.srcFile) : '';

                if(adIndex > -1){
                    this.$store.dispatch('SUBMIT_AD_DESIGN', { ad: ad, index: this.adIndex });
                } else {
                    this.$store.dispatch('CREATE_AD_DESIGN', ad);
                }
            });

            this.ads = this.sliderAds;
        },
        setDialogControl(val) {
            this.openDialog = val
        },
        positionedTop(position) {
            return position === 'Top'
        },
        positionedCenter(position) {
            return position === 'Center'
        },
        positionedBottom(position) {
            return position === 'Bottom'
        },
        setTargetMarket(index){
            this.$router.push({ name: 'business-target-markets', params: { adIndex: index } });
        },
        setActive(index) {
            this.currentIndex = index;
            const localId = this.selectedAd.localId;
            const activeIndex = this.$store.state.tempAdvertisements.findIndex(s => s && s.localId === localId);

            console.log(activeIndex);

            if(activeIndex > -1){
                this.$store.dispatch('ACTIVATE_AD', activeIndex);
                this.$store.dispatch('UPDATE_ADVERTISEMENTS').then(() => {
                    console.log('updated!');
                    this.$router.push({ name: 'business-target-markets', params: { adIndex: activeIndex } });
                });
            } else {
                console.log('not found' + localId);
            }
        },
    },
    computed: {
        activationIcon() {
            return require('../../../assets/Activate-Icon.svg')
        },
        partnerId(){
            return this.$store.getters.partnerId;
        },
        localAds(){
            return this.$store.state.tempAdvertisements || [];
        },
        focusedAd() {
            return this.ads[this.focusedIndex];
        },
        sliderAds(){
            return this.$store.getters.sliderAds || null;
        },
        selectedAd(){
            return this.ads[this.currentIndex];
        },
        targetMarket(){
            return require('../../../assets/Target-Market.svg');
        }
    },
}
</script>
